import { SelectValidate } from '@/components/selectValidate';
import { ReasonAndSubReasonValues } from '@/modules/attendance/entities/attendance';
import { ReasonAndSubReason } from '@/modules/attendance/entities/types';
import {
  useReasonAndSubReasonLocal
} from '@/modules/attendance/hooks/useReasonAndSubReasonLocal/useReasonAndSubReasonLocal';
import React from 'react';
import { ObjectType } from '@/shared/entities/types';

export interface SelectReasonAndSubReasonProps {
  isDisabled?: boolean;
  values: ReasonAndSubReasonValues;
  onChangeSelect: (name: ReasonAndSubReason, value: string) => void;
  small?: boolean;
  showLabel?: boolean;
  showPlaceholder?: boolean;
  required?: boolean;
  useErrors?: ObjectType;
  onBlur?: Function;
  onChange?: Function;
}

export const SelectReasonAndSubReason: React.FC<SelectReasonAndSubReasonProps> = ({
  isDisabled,
  values,
  onChangeSelect,
  small,
  showLabel,
  showPlaceholder,
  required,
  useErrors,
  onBlur,
  onChange,
}) => {
  const { reasonOptions, subReasonOptions } =
    useReasonAndSubReasonLocal({ reasonValue: values.reason });

  const handlerReasonSubReasonChange = (name: ReasonAndSubReason, value: string) => {
    if (name === 'reason' && values.subReason) {
      onChangeSelect('subReason', '');
    }
    onChangeSelect(name, value);
  };

  return (
    <>
      <SelectValidate
        disabled={isDisabled}
        data={reasonOptions?.length ? reasonOptions : null}
        label={showLabel ? 'Motivo' : undefined}
        placeholder={showPlaceholder ? 'Motivo' : undefined}
        name='reason'
        useValues={values}
        small={small}
        required={required}
        useErrors={useErrors}
        onBlur={onBlur}
        onChange={(name: string, value: any) => {
          onChange?.(name, value);
          onBlur?.(name, value);
          handlerReasonSubReasonChange(name as ReasonAndSubReason, value);
        }}
      />
      <SelectValidate
        disabled={!values.reason || !subReasonOptions?.length || isDisabled}
        data={subReasonOptions?.length ? subReasonOptions : null}
        label={showLabel ? 'Submotivo' : undefined}
        placeholder={showPlaceholder ? 'Submotivo' : undefined}
        name='subReason'
        useValues={values}
        small={small}
        required={required && !!values.reason}
        useErrors={useErrors}
        onBlur={onBlur}
        key={`subreason-${values.reason}`}
        onChange={(name: string, value: any) => {
          onChange?.(name, value);
          onBlur?.(name, value);
          handlerReasonSubReasonChange(name as ReasonAndSubReason, value);
        }}
      />
    </>
  );
};
